import BarcodeService from 'components/barcode/barcode.service';
import { useCallback } from 'react';
import { LinhaCupomTroca, RegistroCupomTrocaImpressao } from './cupom-troca.model';
import CupomTrocaService from './cupom-troca.service';
import { agruparSelecionadosPorPedidoVendaItem } from './cupom-troca.util';

const useCupomTroca = () => {
    const cupomTrocaService = CupomTrocaService();
    const barcodeService = BarcodeService();

    const gerarRegistrosImpressao = useCallback(
        async (
            pedidoVendaUuid: string,
            selecionados: Array<LinhaCupomTroca>,
        ): Promise<Array<RegistroCupomTrocaImpressao>> => {
            const descricaoPorPedidoVendaItem = new Map(
                selecionados.map(item => [item.pedidoVendaItemUuid, item.descricao]),
            );

            const { data: registrosGerados } = await cupomTrocaService.gerarSkuTrocaSerial(
                pedidoVendaUuid,
                agruparSelecionadosPorPedidoVendaItem(selecionados),
            );

            return Promise.all(
                registrosGerados.map(async registro => {
                    const { data: barcodeBlob } = await barcodeService.getBarcode(registro.codigo);
                    return {
                        codigo: registro.codigo,
                        barcodeUrl: URL.createObjectURL(barcodeBlob),
                        descricaoSku: descricaoPorPedidoVendaItem.get(registro.pedidoVendaItemUuid) ?? '',
                    };
                }),
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    return { gerarRegistrosImpressao };
};

export default useCupomTroca;
